import { useStations } from '@app/core/stations/hooks/useStations';
import { useFragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs } from '@mi-front/api-clients';

export function useDeliveryEnabledStations() {
  const stations = useStations();

  const { data: enabledStations } =
    useFragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs();

  return stations.filter((station) =>
    enabledStations
      ?.filter((e) => e.config?.enabled)
      .map((e) => e.stationId)
      ?.includes(station.id),
  );
}
